/**
 * Voice event types for durable event recording + the gateway bridge (voice:*).
 */
export enum VoiceEventType {
  VOICE_CREATED = 'voice:created',
  VOICE_UPDATED = 'voice:updated',
  VOICE_DELETED = 'voice:deleted',
  VOICE_SYNTHESIZED = 'voice:synthesized',
}

/**
 * Pub/sub channel for voice events (gateway bridge → socket.io room voice:updates).
 */
export const VOICE_EVENTS_CHANNEL = 'voice:events';